export default __webpack_public_path__ + "static/small-image-bimp-3-79ade86b374c0076a6bbe0d34f67ca6e.png";